module.exports = __webpack_public_path__ + "static/media/generate-team.svg.613d62bf.png";